// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__riWc-","buttons":"PendingPaymentAlert_buttons__xSrRK"};